import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import {
  NotificationRule,
  NotificationCategory,
  NotificationType,
  NotificationFrequency,
  EntityFilters,
} from 'types/notification_rule';

import { useAPI } from 'hooks/api/useAPI';

export type UpdateNotificationRuleParams = {
  id: string;
  name?: string;
  enabled?: boolean;
  notification_categories?: NotificationCategory[];
  notification_types?: NotificationType[] | null;
  user_group_ids?: string[];
  frequency?: NotificationFrequency;
  title_keywords?: string[];
  entity_filters?: EntityFilters | null;
};

export function useUpdateNotificationRule({
  onSettled,
  ...options
}: UseMutationOptions<
  NotificationRule,
  APIError,
  UpdateNotificationRuleParams
> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async ({ id, ...params }) => {
      const { data } = await client.put<NotificationRule>(
        `/apps/${applicationID}/notification_rules/${id}`,
        params
      );
      return data;
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['notification-rules']);
      },
    }
  );
}
